import BaseModel from "./BaseModel";
import RegionType from "./Enums/RegionType";

// We don't automatically pull the GeoJSON for ROIs.
// This is because they can be large multiple-MB structures, in particular for TTW types.
class ROI extends BaseModel {
	constructor(data) {
		super({}, ROI.defaults);
		this.data = data;
	}

	isNew() {
		return typeof this.id === "undefined" || this.id === -1;
	}

	get id() {
		return this.get("id");
	}

	get name() {
		return this.get("name");
	}

	get geojson() {
		return this.get("geojson");
	}

	set geojson(str) {
		this.set("geojson", str);
	}

	get regionType() {
		return this.get("region_type");
	}

	get lastUpdated() {
		return this.get("last_updated");
	}

	set lastUpdated(time) {
		this.set("last_updated", time);
	}

	hasGeoJSON() {
		return this.geojson.length > 0;
	}

	update(data) {
		super.setData(data);
	}

	asSaveData() { // We don't want to save the geojson into the main auth store.
		return {
			id: this.data.id,
			name: this.data.name,
			region_type: this.data.region_type,
			last_updated: this.data.last_updated
		};
	}
}
ROI.defaults = { // Defaults
	id: -1,
	name: "",
	region_type: RegionType.ROI,
	geojson: "",
	last_updated: 0
};

export default ROI;
